import { LogLevel } from "angular-auth-oidc-client";

export const environment = {
  production: false,
  auth: {
    clientID: '591e0876-8267-4be7-a226-14f5318be2d7',
    postLogoutRedirectUri:'https://wede.appsqa.tenaris.com/login',
    logLevel: LogLevel.Debug
  },
  apiEndpoint: 'https://wede.appsqa.tenaris.com/api/',
  hubEndpoint: 'https://wede.appsqa.tenaris.com/',
  manualsUrl: {
    corrosionRate: 'https://tenaris.sharepoint.com/:b:/s/Apps-Wede-QA/EY9C2LV_JdRDgLtv_GX_jbIBZtK1DnYEa4UHHgr7tYABMw',
    corrosionClas: 'https://tenaris.sharepoint.com/:b:/s/Apps-Wede-QA/EXLiLK5lAZ5EgdWto4lFtp0BgZuqW3nHQimPy4bZ1A7vbg',
    casingWear: 'https://tenaris.sharepoint.com/:b:/s/Apps-Wede-QA/IQCa1Rv1u1IxT7GPfwZCeBaLASHKPGPEtciqUFb6bBXDiZo',
    slottedPipe: 'https://tenaris.sharepoint.com/:b:/s/Apps-Wede-QA/ER6VPW4F1QJHixC3mViuHwkBeWDeqbSj3KJRNMx9XG3zkA?e=OKwNWQ',
    prePerforatedPipe: 'https://tenaris.sharepoint.com/:b:/s/Apps-Wede-QA/EWTIeyz7D7NNn2O61MMkYuUBD9AFBThL2icMfI8VXVEaMw?e=bcr1J8',
    matSelGuidelines: 'https://tenaris.sharepoint.com/:b:/s/Apps-Wede-QA/EZJvF1TlFDxJmm6W5kCDB2oBfLZM1QiLC8Oqy1-v8NQpaA?e=23eApt',
    geothermal: 'https://tenaris.sharepoint.com/:b:/s/Apps-Wede-QA/IQBNQfwnu7i0QYwOlB9sLC3JATDQbrYV0yB_TdxSJWkbzqo',
    advancedPipeRatings: 'https://tenaris.sharepoint.com/:b:/s/Apps-Wede-QA/IQA62Rr9mEmwRoR4Ah8o1KYXAcmEcy9zxkoy4xLIsuV7ah0',
  },
  powerBIMetricsReport: 'https://app.powerbi.com/reportEmbed?reportId=52589f06-0743-45c1-bf1c-54e6bff5f32d&autoAuth=true&ctid=a054342c-6f8c-4378-ad61-a8ad00f2b736',
};
